import { DailyLetter } from '../types';
import { formatDateSpanish } from './storage';

/**
 * Determina si una carta está actualmente sellada y bloqueada en la cápsula del tiempo.
 * Regla: Si tiene una fecha programada en el futuro (unlockDate o date > hoy),
 * la carta permanece estrictamente sellada y ni el autor ni la pareja pueden abrirla.
 */
export function isLetterSealed(letter?: DailyLetter | null): boolean {
  if (!letter) return false;

  const targetDateStr = letter.unlockDate || letter.date;
  if (!targetDateStr) return false;

  // Obtener fecha actual en formato local YYYY-MM-DD
  const now = new Date();
  const year = now.getFullYear();
  const month = String(now.getMonth() + 1).padStart(2, '0');
  const day = String(now.getDate()).padStart(2, '0');
  const todayStr = `${year}-${month}-${day}`;

  // Si la fecha de apertura es posterior a hoy, está estrictamente bloqueada
  return targetDateStr > todayStr;
}

export interface LetterCountdown {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
  totalSeconds: number;
  isUnlocked: boolean;
  formattedTargetDate: string;
}

/**
 * Calcula el tiempo restante exacto hasta la medianoche (00:00:00) del día de apertura acordado.
 */
export function getLetterCountdown(letter?: DailyLetter | null): LetterCountdown {
  const targetDateStr = letter?.unlockDate || letter?.date || '';
  const formattedTargetDate = formatDateSpanish(targetDateStr);

  if (!targetDateStr) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalSeconds: 0,
      isUnlocked: true,
      formattedTargetDate,
    };
  }

  // La apertura es al comenzar el día acordado (00:00:00 en hora local)
  const targetTime = new Date(`${targetDateStr}T00:00:00`).getTime();
  const nowTime = Date.now();
  const diffMs = targetTime - nowTime;

  if (diffMs <= 0) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      totalSeconds: 0,
      isUnlocked: true,
      formattedTargetDate,
    };
  }

  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return {
    days,
    hours,
    minutes,
    seconds,
    totalSeconds,
    isUnlocked: false,
    formattedTargetDate,
  };
}
